import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from 'app/queries/types/TCall';
import { transcriptPlayerKeys } from './transcriptPlayerKeys';

export const createFetchTranscriptQueryFn =
  (call: TCall) =>
  ({
    queryKey: [{ jobId, transcript }],
    signal,
  }: QueryFunctionContext<ReturnType<typeof transcriptPlayerKeys.detail>>) =>
    call(() => cancelOnSignal(AdminService.getJobUtterances({ jobId, transcript }), signal), {
      dontRedirectOnError: true,
      onError: () => {},
    });
